// Čista logika za novi izgled ekrana radnika (EmployeeViewNovi.vue).

// Vrijednost je "prazna" ako nije upisana. Nula JE upisana vrijednost.
export const jePrazno = (v) => v === null || v === undefined || (typeof v === 'string' && v.trim() === '')

// Račun (1 ili 2) ima podataka ako je upisan ikakav broj računa (i IBAN koji
// počinje slovima) ili naziv banke. Stari izgled je tražio Nr1 > 0, pa se IBAN
// "HR..." nije vidio.
export const bankaImaPodatke = (e, n) => {
  const ne = (v) => !jePrazno(v) && String(v).trim() !== '0'
  return ne(e['Fin' + n + 'bankAccountNr1']) || ne(e['Fin' + n + 'bankAccountName'])
}

// Izbor izgleda ekrana (novi/stari) pamti se u localStorage; ako ne radi, zadano je novi.
const KLJUC = 'employeeViewIzgled'
export const citajIzgled = () => {
  try {
    const v = window.localStorage.getItem(KLJUC)
    return v === 'stari' ? 'stari' : 'novi'
  } catch (e) {
    return 'novi'
  }
}
export const spremiIzgled = (izgled) => {
  try {
    window.localStorage.setItem(KLJUC, izgled)
  } catch (e) {
    // ignore
  }
}
